const requestStates = Object.freeze({
  idle: 0,
  loading: 1,
  success: 2,
  error: 3,
});

export default requestStates;
